import { Form } from 'informed';
import styled from 'styled-components';
import tw from 'twin.macro';

import { colors } from '@nw/shared/ui';

export const PublicRegistrationFormContainer = styled(Form)`
  ${tw`flex flex-col w-full justify-between items-center overflow-auto p-1 h-full`}
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${colors.geyser};
    border-radius: 8px;
  }
`;
